module.exports = __webpack_public_path__ + "static/media/20200113_162338.1d1a35ce.jpg";